// File generated from our OpenAPI spec by Stainless.
import { APIResource } from 'openai/resource';
export class Completions extends APIResource {
  create(body, options) {
    var _body$stream;
    return this._client.post('/chat/completions', {
      body,
      ...options,
      stream: (_body$stream = body.stream) !== null && _body$stream !== void 0 ? _body$stream : false
    });
  }
}
(function (Completions) {})(Completions || (Completions = {}));